import { PermUsuario } from '../../model/usuario/perm-usuario';
import { UsuarioLogadoUtil } from '../../util/usuario-logado-util';
import { UsuarioLogadoStorageService } from "../../storage/usuario/usuario-logado-storage.service";
import { Usuario } from '../../model/usuario/usuario';

export interface BadgeItem {
    type: string;
    value: string;
}

export interface ChildrenItems {
    state: string;
    target?: boolean;
    short_label?: string;
    main_state?: string;
    name: string;
    type?: string;
    children?: ChildrenItems[];
}

export interface MainMenuItems {
    state: string;
    target?: boolean;
    name: string;
    type: string;
    icon: string;
    badge?: BadgeItem[];
    children?: ChildrenItems[];
    external?: string;
    short_label?: string;
    main_state?: string;
}

export interface Menu {
    label: string;
    main: MainMenuItems[];
}

const ITEM_MERCADO: ChildrenItems = {
    state: 'mercado',
    short_label: 'M',
    name: 'Mercado',
    type: 'link',
    main_state: 'cadastro'
};

const ITEM_FORNECEDOR: ChildrenItems = {
    state: 'fornecedor',
    short_label: 'F',
    name: 'Fornecedor',
    type: 'link',
    main_state: 'cadastro'
};

const ITEM_FILIAL: ChildrenItems = {
    state: 'filial',
    short_label: 'F',
    name: 'Filial',
    type: 'link',
    main_state: 'cadastro'
};

const ITEM_VENDEDOR: ChildrenItems = {
    state: 'vendedor',
    short_label: 'F',
    name: 'Vendedor',
    type: 'link',
    main_state: 'cadastro'
};

const ITEM_COTACAO: ChildrenItems = {
    state: 'cotacao',
    short_label: 'C',
    name: 'Cotação',
    type: 'link',
    main_state: 'movimentacao'
}

const ITEM_PEDIDO: ChildrenItems = {
    state: 'pedido',
    short_label: 'P',
    name: 'Pedido',
    type: 'link',
    main_state: 'cadastro'
}

const ITEM_SITUACAO_COTACAO: ChildrenItems = {
    state: 'status-cotacao',
    short_label: 'S',
    name: 'Situacão da cotação',
    type: 'link',
    main_state: 'relatorio'
};

// const ITEM_RELACAO_ITENS_NAO_GANHO: ChildrenItems = {
//     state: 'cotacao-nao-ganhos',
//     short_label: 'I',
//     name: 'Relação de itens não ganho',
//     type: 'link',
//     main_state: 'relatorio'
// }

const ITEM_USUARIO: ChildrenItems = {
    state: 'usuario',
    short_label: 'S',
    name: 'Usuário',
    type: 'link',
    main_state: 'manutencao'
};

const ITEM_LOG: ChildrenItems = {
    state: 'log',
    short_label: 'S',
    name: 'Log de Operações',
    type: 'link',
    main_state: 'manutencao'
};

const ITEM_VENDEDOR_MERCADO: ChildrenItems = {
    state: 'vendedor-mercado',
    short_label: 'V',
    name: 'Vendedor/Mercado',
    type: 'link',
    main_state: 'cadastro'
};

const MENUITEM_RELATORIOS: MainMenuItems = {
    state: 'relatorio',
    short_label: 'R',
    name: 'Relatórios',
    type: 'sub',
    icon: 'icofont icofont-newspaper',
    children: [ ITEM_SITUACAO_COTACAO,/* ITEM_RELACAO_ITENS_NAO_GANHO */ ]
};

export class MenuItems {

    public static buildMenu(permissoes: PermUsuario[]): Menu[] {
        let menu: Menu = {
            label: 'Menu',
            main: []
        }

        this.buildItemCadastro(menu.main, permissoes);
        this.buildItemMovimentacao(menu.main, permissoes);
        this.buildItemRelatorios(menu.main, permissoes);
        this.buildItemManutencoes(menu.main, permissoes);

        return [menu];
    }

    private static buildItemCadastro(main: MainMenuItems[], permissoes: PermUsuario[]) {
        let usuarioLogadoService : UsuarioLogadoStorageService = new UsuarioLogadoStorageService();

        let usuario : Usuario = usuarioLogadoService.get().usuario;

        let itemMenu: MainMenuItems = {
            state: 'cadastro',
            short_label: 'C',
            name: 'Cadastros',
            type: 'sub',
            icon: 'icofont icofont-tasks',
            children: []
        };

        if (UsuarioLogadoUtil.hasPermission(permissoes, 'Mercado'))
            itemMenu.children.push(ITEM_MERCADO);

        if (UsuarioLogadoUtil.hasPermission(permissoes, 'Fornecedor'))
            itemMenu.children.push(ITEM_FORNECEDOR);

        if( usuario.tipo == 'FO' )
            itemMenu.children.push(ITEM_VENDEDOR_MERCADO);

        if (UsuarioLogadoUtil.hasPermission(permissoes, 'Filial'))
            itemMenu.children.push(ITEM_FILIAL);

        if (UsuarioLogadoUtil.hasPermission(permissoes, 'Vendedor'))
            itemMenu.children.push(ITEM_VENDEDOR);

        main.push(itemMenu)
    }

    private static buildItemMovimentacao(main: MainMenuItems[], permissoes: PermUsuario[]) {
        let itemMenu: MainMenuItems = {
            state: 'movimentacao',
            short_label: 'M',
            name: 'Movimentações',
            type: 'sub',
            icon: 'icofont icofont-settings-alt',
            children: [  ]
        }

        if (UsuarioLogadoUtil.hasPermission(permissoes, 'ListarCotacao'))
            itemMenu.children.push(ITEM_COTACAO);

        if (UsuarioLogadoUtil.hasPermission(permissoes, 'ListarPedido'))
            itemMenu.children.push(ITEM_PEDIDO);

        main.push(itemMenu);
    }

    private static buildItemRelatorios(main: MainMenuItems[], permissoes: PermUsuario[]) {
        let itemMenu: MainMenuItems = {
            state: 'relatorio',
            short_label: 'R',
            name: 'Relatórios',
            type: 'sub',
            icon: 'icofont icofont-newspaper',
            children: []
        };

        if (UsuarioLogadoUtil.hasPermission(permissoes, 'ImprimirCotacao'))
            itemMenu.children.push(ITEM_SITUACAO_COTACAO);

        // if (UsuarioLogadoUtil.hasPermission(permissoes, 'ListarPedidonaoGanho'))
        //     itemMenu.children.push(ITEM_RELACAO_ITENS_NAO_GANHO);

        main.push(itemMenu);
    }

    private static buildItemManutencoes(main: MainMenuItems[], permissoes: PermUsuario[]) {
        let itemMenu: MainMenuItems = {
            state: 'manutencao',
            short_label: 'R',
            name: 'Manutenções',
            type: 'sub',
            icon: 'icofont icofont-tools-alt-2',
            children: []
        };

        if (UsuarioLogadoUtil.hasPermission(permissoes, 'Usuario'))
            itemMenu.children.push(ITEM_USUARIO);

        if (UsuarioLogadoUtil.hasPermission(permissoes, 'LogOperacoes'))
            itemMenu.children.push(ITEM_LOG);

        main.push(itemMenu);
    }
}
